import React, { useState } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Loader2, EyeOff } from 'lucide-react';

// Dialog générique « Écarter » : rappelle la cause (signalement / alerte / difficulté) et impose un motif d'écart tracé
export const EcarterDialog = ({ open, onOpenChange, titre, cause, onConfirm, confirmLabel = 'Écarter', testId = 'ecarter-dialog' }) => {
  const [motif, setMotif] = useState('');
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (!motif.trim()) return;
    setBusy(true);
    try { await onConfirm(motif.trim()); setMotif(''); onOpenChange(false); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!busy) { onOpenChange(o); if (!o) setMotif(''); } }}>
      <DialogContent className="max-w-lg" data-testid={testId}>
        <DialogHeader><DialogTitle className="flex items-center gap-2 text-slate-800"><EyeOff className="w-4 h-4 text-slate-500" /> {titre}</DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <div className="rounded-lg border border-orange-200 bg-orange-50 p-3 text-xs text-orange-900 space-y-1" data-testid={`${testId}-cause`}>
            <p className="text-[10px] uppercase tracking-wide font-semibold text-orange-600">Cause écartée</p>
            {cause}
          </div>
          <div>
            <label className="text-xs font-medium text-slate-700">Pourquoi écartez-vous cette information ? <span className="text-red-500">*</span></label>
            <Textarea value={motif} onChange={(e) => setMotif(e.target.value)} rows={3} placeholder="Ex. : entretien avec le candidat le 12/09, absence justifiée par un arrêt maladie, situation régularisée…" className="mt-1 text-sm" data-testid={`${testId}-motif`} />
            <p className="text-[10px] text-slate-400 mt-1">Ce motif est conservé avec la cause écartée et reste consultable sur la fiche du candidat.</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy} data-testid={`${testId}-annuler`}>Annuler</Button>
          <Button onClick={go} disabled={busy || !motif.trim()} className="bg-slate-800 hover:bg-slate-900" data-testid={`${testId}-confirmer`}>{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
